import Grid2 from '@mui/material/Unstable_Grid2';
import HomeIcon from '@mui/icons-material/Home';
import { useTranslation } from 'react-i18next';
import Select from 'src/shared/components/Form/Select';
import { type BukCompany } from 'src/shared/api/integrations/buk';
import { Step } from '../../components/Step';
import { mapBukCompaniesForSelect } from '../utils';

type Step2Props = {
  companies: BukCompany[];
};

export const Step2 = ({ companies }: Step2Props) => {
  const { t } = useTranslation('settings');
  const mappedData = mapBukCompaniesForSelect(companies);

  return (
    <Step
      title={`${t('integrations.step')} 2`}
      subtitle={t('integrations.buk.select the company you want to synchronize')}
      Icon={HomeIcon}
    >
      <Grid2 xs={12}>
        <Select sx={{ maxWidth: '300px' }} data={mappedData} label={t('integrations.buk.company')} name="company_id" />
      </Grid2>
    </Step>
  );
};
